import React, { useEffect, useState } from "react";
import { fetchAdminFreeBundles, updateFreeBundleById } from "../../common/services/freeBundleService";
import { useToast } from "../../common/toast/ToastContext";

const PLAN_EMOJI = { GROUP: "🧑🤝🧑", ONE_ON_ONE: "👤", PARTNER_PRACTICE: "🤝" };

const th = { padding: "10px 14px", fontWeight: 600, fontSize: "0.9rem" };
const td = { padding: "12px 14px" };

const AdminFreeBundlePage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const { showToast } = useToast();

  useEffect(() => {
    fetchAdminFreeBundles()
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch(() => showToast("Failed to load free bundle config", "error"))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (id, field, value) => {
    setRows((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [field]: value } : r))
    );
  };

  const handleSave = async (row) => {
    setSaving((prev) => ({ ...prev, [row.id]: true }));
    try {
      const updated = await updateFreeBundleById(row.id, {
        sessions: Number(row.sessions),
        isActive: row.isActive,
      });
      setRows((prev) => prev.map((r) => (r.id === updated.id ? updated : r)));
      showToast("Saved successfully", "success");
    } catch {
      showToast("Failed to save. Please try again.", "error");
    } finally {
      setSaving((prev) => ({ ...prev, [row.id]: false }));
    }
  };

  if (loading) return <p style={{ padding: 24 }}>Loading...</p>;

  return (
    <div style={{ padding: 24, maxWidth: 700 }}>
      <h2 style={{ marginBottom: 24 }}>Free Bundle Management</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
            <th style={th}>Session Type</th>
            <th style={th}>Sessions</th>
            <th style={th}>Active</th>
            <th style={th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={td}>
                {PLAN_EMOJI[row.planType]} {row.displayName}
              </td>
              <td style={td}>
                <input
                  type="number"
                  min={0}
                  value={row.sessions}
                  onChange={(e) => handleChange(row.id, "sessions", e.target.value)}
                  style={{ width: 70, padding: "6px 8px", borderRadius: 6, border: "1px solid #ccc" }}
                />
              </td>
              <td style={td}>
                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={row.isActive}
                    onChange={(e) => handleChange(row.id, "isActive", e.target.checked)}
                  />
                  {row.isActive ? "Active" : "Inactive"}
                </label>
              </td>
              <td style={td}>
                <button
                  onClick={() => handleSave(row)}
                  disabled={saving[row.id]}
                  style={{
                    padding: "7px 18px",
                    borderRadius: 6,
                    border: "none",
                    background: "#028891",
                    color: "#fff",
                    cursor: saving[row.id] ? "not-allowed" : "pointer",
                    opacity: saving[row.id] ? 0.7 : 1,
                    fontWeight: 500,
                  }}
                >
                  {saving[row.id] ? "Saving..." : "Save"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminFreeBundlePage;
